// Path: src\Components\HtmlFreeGames\HtmlFreeGameDirectLink.JSX
import React from "react";
import BaseHome from "../Home/BaseHome";
import Games from "../../assets/images/games.svg";
import Game from "../../images/box.png";
import { useTranslation } from "react-i18next";


const HtmlFreeGames = () => {
    const { t } = useTranslation();
    return (
        <BaseHome title="Direct Link" isFreeGameIframe={true}>
               <div style={{ height: '100vh', width: '100%', overflow: 'hidden' }}>
        <iframe 
          src="https://gamerji.mudgames.in/app/store/home/#google_vignette" 
          title="External Site"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      </div>
        </BaseHome>
    );
};

export default HtmlFreeGames;
